var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubmit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    viewBox: "0 0 25 25",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#136ffb",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.5 23.4375c2.9008 0 5.6828-1.1523 7.734-3.2035s3.2035-4.8332 3.2035-7.734c0-2.90081-1.1523-5.6828-3.2035-7.73398s-4.8332-3.20352-7.734-3.20352c-2.90081 0-5.6828 1.15234-7.73398 3.20352s-3.20352 4.83317-3.20352 7.73398c0 2.9008 1.15234 5.6828 3.20352 7.734s4.83317 3.2035 7.73398 3.2035zm0 1.5625c3.3152 0 6.4946-1.317 8.8388-3.6612s3.6612-5.5236 3.6612-8.8388c0-3.31521-1.317-6.49463-3.6612-8.83883-2.3442-2.34421-5.5236-3.66117-8.8388-3.66117-3.31521 0-6.49463 1.31696-8.83883 3.66117-2.34421 2.3442-3.66117 5.52362-3.66117 8.83883 0 3.3152 1.31696 6.4946 3.66117 8.8388 2.3442 2.3442 5.52362 3.6612 8.83883 3.6612z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.7051 17.7406v-5.1152-4.25976c0-1.10625 0 0 0-1.10625.0726-.07264.1588-.13026.2538-.16957.0949-.03931.1966-.05955.2993-.05955s.2044.02024.2994.05955c.0949.03931.1811.09693.2537.16957l4.6875 4.68751c.0728.0726.1305.1588.1699.2537s.0597.1967.0597.2994c0 .1028-.0203.2045-.0597.2994-.0394.095-.0971.1812-.1699.2537l-4.6875 4.6875c-.0725.0728-.1588.1305-.2537.1699s-.1966.0597-.2994.0597-.2045-.0203-.2994-.0597-.1812-.0971-.2537-.1699z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.75781 12.5c0-.2072.08231-.4059.22883-.5524.14651-.1465.34522-.2288.55242-.2288h7.81254c.2072 0 .4059.0823.5524.2288s.2288.3452.2288.5524-.0823.4059-.2288.5524-.3452.2288-.5524.2288h-7.81254c-.2072 0-.40591-.0823-.55242-.2288-.14652-.1465-.22883-.3452-.22883-.5524z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/Submit.440a0534.svg";
export { ForwardRef as ReactComponent };